import { APIPost, APIGet, APIPostMb } from 'utilities/APIRequestHelper'
import { taggingDownloadDocumentError, taggingDownloadDocumentSuccess } from 'routes/bringAccount/helpers/bringAccountTagging';

import { i18n } from 'core/i18n'
import apiURLBuilder from 'core/apiURLBuilder'
import notification from 'actions/notifications'
import { openPDFViewer } from 'utilities/contactCenter/pdfViewer';
import { base64ToBlob } from 'utilities/APIRequestHelper'
import { downloadFileFromUrl } from 'utilities/fileDownloadHelper';
import { LANGUAGE_COUNTRY_CODES }  from 'constants/countries';
import { DATE_FORMAT_API } from 'constants/index';

const { formatText, getLanguage } = i18n

import {
    TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_SET_VALIDATE,
    TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_VALIDATE,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_RESET,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_IBAN,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE_INVALID,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_REQUEST,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_SUCCESS,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_FAILURE,
    TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_UPDATE_CHECKBOX,
    TRANSFER_ACCOUNT_SEND_REQUEST,
    TRANSFER_ACCOUNT_SEND_SUCCESS,
    TRANSFER_ACCOUNT_SEND_FAILURE,
    TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE,
    TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST,
    TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS,
} from "constants/actionTypes";

const setVisibleStep = (step) => ({
    type: TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_SET_VALIDATE,
    payload: {
        step
    }
});

const validateStep = step => ({
    type: TRANSFER_ACCOUNT_FROM_ANOTHER_BANK_VALIDATE,
    payload: {
        step
    }
});

const resetTransferState = () => ({
    type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_RESET
});

const setIbanToTransfer = (ibanNumber, isValidIbanNumber) => ({
    type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_IBAN,
    payload: {
        ibanNumber,
        isValidIbanNumber
    }
});

const setExecutionDate = (executionDate) => {
    return {
        type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE,
        payload: {
            executionDate
        }
    }
}

const setInvalidExecutionDate = () => {
    return {
        type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_SET_APPLICATION_DATE_INVALID,
    }
}

const updateAuthoriseCheckbox = (checkboxGroup, { name, isChecked }) => {
    return {
        type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_UPDATE_CHECKBOX,
        payload: {
            checkboxGroup,
            name,
            isChecked
        }
    }
}

const getEntityNameRequest = () => ({
    type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_REQUEST
});

const getEntityNameSuccess = (response) => ({
    type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_SUCCESS,
    payload: {
        response
    }
});

const getEntityNameFailure = (error) => ({
    type: TRANSFER_ACCOUNT_FRON_ANOTHER_BANK_ENTITY_NAME_FAILURE,
    payload: {
        error
    }
});

const downloadTransferDocumentRequest = () => ({
    type: TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST
});

const downloadTransferDocumentSuccess = () => ({
    type: TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS
});

const downloadTransferDocumentFailure = () => ({
    type: TRANSFER_ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE
});

const getEntityName = (ibanNumber) => (dispatch) => {
    dispatch(getEntityNameRequest());
    const params = {
        query: {
            iban: ibanNumber
        }
    };
    return APIPost(dispatch, apiURLBuilder.getURL('banknameIban'), params)
        .then(response => dispatch(getEntityNameSuccess(response)))
        .catch(error => dispatch(getEntityNameFailure(error)));
};

const sendTransferRequest = () => ({
    type: TRANSFER_ACCOUNT_SEND_REQUEST
})

const sendTransferSuccess = (response) => ({
    type: TRANSFER_ACCOUNT_SEND_SUCCESS,
    payload: {
        response
    }
})

const sendTransferFailure = ({ error }) => ({
    type: TRANSFER_ACCOUNT_SEND_FAILURE,
    payload: {
        error
    }
})

const sendTransferFetch = ({ originAccountNumber, destinationAccountNumber, targetDate, requestsOriginBank1, requestsOriginBank2 }) => (dispatch) => {
    dispatch(sendTransferRequest())
    const acceptLanguage = LANGUAGE_COUNTRY_CODES[getLanguage()] || LANGUAGE_COUNTRY_CODES[DEFAULT_ORIGIN_COUNTRY];
    const params = {
        header: {
            "accept-language": acceptLanguage,
        },
        query: {
            originAccountNumber,
            destinationAccountNumber,
            targetDate: targetDate.format(DATE_FORMAT_API),
            requestsOriginBank1,
            requestsOriginBank2,
        }
    };

    return APIPostMb(null, apiURLBuilder.getModelURL('transferAccount'), params)
        .then(response => dispatch(sendTransferSuccess(response)))
        .catch(error => dispatch(sendTransferFailure(error)));
};

const downloadTransferDocument = (documentId) => (dispatch) => {
    dispatch(downloadTransferDocumentRequest());

    return APIGet(dispatch, apiURLBuilder.getURL('apiDocumentById', { documentId }))
      .then(response => {
        const notitifactionMessage = formatText('transfer_account-transfer_account_from_another_bank_success_screen_snackbar_ok');

        dispatch(notification.success({ message: notitifactionMessage },  { voice: notitifactionMessage }))
        dispatch(downloadTransferDocumentSuccess())
        taggingDownloadDocumentSuccess()

        if (response && response.documentUri) {
          downloadFileFromUrl(response.documentUri, response.documentName);
        }
      })
      .catch(() => {
        const notitifactionMessage = formatText('transfer_account-transfer_account_from_another_bank_success_screen_snackbar_ko');
        dispatch(notification.error({ message: notitifactionMessage },  { voice: notitifactionMessage }))
        taggingDownloadDocumentError(notitifactionMessage)
        dispatch(downloadTransferDocumentFailure());
      });
};

const printTransferDocument = (dmsDocumentId) => (dispatch) => {
    dispatch(downloadTransferDocumentRequest())

    return APIGet(dispatch, apiURLBuilder.getURL('rawDocument', { dmsDocumentId }), {
        header: {
            version: 2
        }
    })
        .then(response => {
            const PDF_BASE64 = response.file;
            openPDFViewer(base64ToBlob(`data:application/pdf;base64,${PDF_BASE64}`), 'transfer-account-from-another-bank-step1')
            dispatch(downloadTransferDocumentSuccess())
        })
        .catch(() => {
            dispatch(downloadTransferDocumentFailure())
        });
}

module.exports = {
    getEntityName,
    resetTransferState,
    setExecutionDate,
    setIbanToTransfer,
    setVisibleStep,
    validateStep,
    updateAuthoriseCheckbox,
    sendTransferRequest: sendTransferFetch,
    downloadTransferDocument,
    printTransferDocument,
    setInvalidExecutionDate,
};
